import { useEffect } from 'react';
import Tooltip from 'presentation/components/tooltip/index.js';
import { useTimeout } from 'presentation/hooks';

export default function TimedTooltip(props) {
    const {
        mojitoTools: { config, stringResolver },
        onClose,
        class: className,
    } = props;

    const delay = !isNaN(config.duration) ? 1000 * config.duration : -1;
    const { startTimer } = useTimeout(delay, onClose);

    useEffect(() => {
        delay > -1 && startTimer();
    }, [delay, startTimer]);

    return (
        <Tooltip
            config={config.tooltip}
            onClick={onClose}
            onClose={onClose}
            text={stringResolver.resolveString(config.l10nText)}
            class={className}
        />
    );
}
